import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function blockTrainersSliderScript() {
    document.addEventListener( 'DOMContentLoaded', function () {
        const blocksTrainers = document.querySelectorAll('.trainers__slider');

        blocksTrainers.forEach(block=>{
            let trainersNH = new Splide(block, {
                type  : 'loop',
                // rewind: false,
                // autoplay: false,
                perPage: 4,
                gap: 6,
                perMove: 1,
                pagination:false,
                arrows: true,
                // interval: 0,
                // speed: 8000,
                breakpoints: {
                    992: { perPage: 3, arrows: false },
                    599: { perPage: 1, arrows: false,padding: {  right: '5rem'} },
                },
            });

            trainersNH.mount()
        });
    })
}